<div class="col-sm-12 offset-md-1 col-md-10 mt-3">
    <div class="form-logo">
        <a href="javascript:void(0)" (click)="openLink('HOMPAGE_BASE_URL','','_self');">
            <img [src]="this.logo_url" alt="egd-logo">
        </a>
    </div>
    <div class="col-12">
        <div class="d-flex justify-content-center align-items-center">
            <img src="assets/images/thank-you/successful.gif" alt="" class="successful-logo">
        </div>
    </div>
    <div class="text-center">
        <h2 class="egd-theme-text"> Thank you for choosing eGlobalDoctors</h2>
        <p class="text-black mb-5  WordWrap" id="user-tpe-text"></p>

        <button type="button" [routerLink]="['/', this.slug]"
        class="btn btn-default btn-primary egd-theme-white-bg-btn mx-2"
            role="button">
            <span class="egd-theme-white-bg-btn-label ">
                Go to Login Page
            </span>
        </button>
    </div>
</div>
